import React from "react"
import TeamInfo from "@/business-components/sale/TeamInfo"
import UserInfo from "@/business-components/sale/UserInfo"
import EmployeeInfo from "@/business-components/sale/EmployeeInfo"
import LeaderStar from "@/business-components/sale/LeaderStar"
import dayjs from "dayjs"

// 表格行的数据类型
export const DataType = {
  TEAM: "TEAM",
  EMPLOYEE: "EMPLOYEE",
  AMOUNT: "AMOUNT",
  AVERAGE: "AVERAGE",
}

// 渲染箭头等
const renderRowSpreador = (type, name, value, data, startDate, endDate) => {
  let result = value
  if (type !== "head" && type !== "total") {
    let marginLeft = data && typeof data._level === "number" ? data._level * 20 : 0
    if (data) {
      if (data._type === DataType.TEAM) {
        result = (
          <span style={{ marginLeft: marginLeft }}>
            <i className="spaui-table-pushdata-arrow" />
            <span className="fa fa-group" style={{ marginRight: 3 }} />
          </span>
        )
      } else if (data._type === DataType.EMPLOYEE) {
        result = (
          <span style={{ marginLeft: marginLeft + 20 }}>
            <span className="fa fa-user" style={{ marginRight: 3 }} />
          </span>
        )
      }
    }
  }
  return result
}

// 渲染负责人星星
const renderLeaderStar = (type, name, value, data, startDate, endDate) => {
  if (type === "head") {
    return value
  }

  switch (data._type) {
    case DataType.TEAM:
      return ""
    case DataType.EMPLOYEE:
      return <LeaderStar teamId={data.teamId} userId={data.employeeId} startDate={startDate} endDate={endDate} />
    default:
      return ""
  }
}

// 渲染团队/个人名称
export const renderName = (type, name, value, data, startDate, endDate) => {
  if (type === "head") {
    return value
  }

  let spreador = renderRowSpreador(type, name, value, data, startDate, endDate)
  let start = renderLeaderStar(type, name, value, data, startDate, endDate)

  switch (data._type) {
    case DataType.TEAM:
      return (
        <div>
          {spreador}
          <TeamInfo teamId={data.teamId} onlyShowLastLevel={true} />（{data.employeeCount}人）
        </div>
      )
    case DataType.EMPLOYEE:
      return (
        <div>
          {spreador}
          <UserInfo userId={data.employeeId} />
          {start}
          <EmployeeInfo employeeId={data.employeeId} treeDate={endDate} />
        </div>
      )
    // case DataType.AMOUNT:
    //   return '汇总'
    // case DataType.AVERAGE:
    //   return '平均值'
    default:
      return "-"
  }
}

// 获取同比
export const getQoQ = (value, lastValue) => {
  if (typeof value !== "number" || typeof lastValue !== "number" || lastValue === 0) {
    return "-"
  }

  let qoq = (((value - lastValue) / lastValue) * 100).toFixed(1) + "%"
  let flag = value > lastValue ? " ↑" : value < lastValue ? " ↓" : " →"
  return qoq + flag
}

// 获取商
export const getDivide = (value, divideValue, percentage = false, toFixed = 2) => {
  if (typeof value !== "number" || typeof divideValue !== "number" || divideValue === 0) {
    return "-"
  }

  if (percentage) {
    return parseFloat((value / divideValue) * 100).toFixed(toFixed) + "%"
  } else {
    return (value / divideValue).toFixed(toFixed)
  }
}

// 渲染数值
export const renderValue = (type, name, value, data) => {
  if (type === "head") {
    return value
  }

  if (typeof value !== "number") {
    return "-"
  } else if (parseInt(value) === parseFloat(value)) {
    return value
  } else {
    return value.toFixed(2)
  }
}
